import { Decimal } from "decimal.js";

export function calcTotalLoss(
  lossRate: Decimal.Value,
  subtotal: Decimal.Value
) {
  return new Decimal(100)
    .minus(lossRate)
    .div(100)
    .times(subtotal)
    .toNumber();
}
